<script setup>
import { ref, computed, onMounted } from 'vue'
import { Card, Label, Input, Select, Textarea, Button, Icon, Breadcrumb, MediaUploaderButton, Tooltip } from '@components'
import { validationCheck, regex } from '@utils'

import BusinessProfileInformation from './BusinessProfileInformation.vue'
import BusinessProfileAddress from './BusinessProfileAddress.vue'

import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

// Settings store.
import { useSettings } from '@store/settings'
const $settings = useSettings()



const saveGeneralSettings = async () => {
    // validation
    // manually sync this validation with settings/ServiceProvider.vue
    let { errors } = validationCheck([
        {
            condition: !$settings.business.full_logo_url,
            message: 'Full logo is required',
        },
        {
            condition: !$settings.business.name && $settings.addons.staffs,
            message: 'Company name is required',
        },
        {
            condition: !$settings.business.type,
            message: `${$settings.addons.staffs ? 'Company' : 'Service'} type is required`,
        },
        {
            condition: !$settings.addons.staffs && !$settings.business.provider_first_name,
            message: 'Provider first name is required',
        },
        {
            condition: !$settings.addons.staffs && !$settings.business.provider_last_name,
            message: 'Provider last name is required',
        },
        {
            condition: !$settings.addons.staffs && !$settings.business.provider_display_name,
            message: 'Provider display name is required',
        },
        {
            condition: !$settings.business.email,
            message: 'Email is required',
        },
        {
            condition: $settings.business.email && !regex.email.test($settings.business.email),
            message: 'Invalid email format',
        },
        {
            condition: $settings.business.phone && !regex.phone.test($settings.business.phone),
            message: 'Invalid phone number format',
        },
    ])
    if (errors) return

    await $settings.saveSettings('business', $settings.business)
    Toast.success('Updated business profile')

    if (route.query.dashboard) {
        router.push({ name: 'dashboard' })
    }
}

const backButton = () => {
    if (route.query.dashboard) {
        router.push({ name: 'dashboard' })
    } else {
        router.push({ name: 'settings' })
    }
}

onMounted(() => {
    if ($settings.addons.staffs == false) {
        console.log('settings.addons.staffs', $settings.addons.staffs)
        router.push({ name: 'settings.provider' })
    }
})
</script>

<template>
    <div class="md:max-w-[736px] m-auto mt-[-28px] transition" :class="{ 'opacity-60 pointer-events-none': $settings.isSaving }">
        <!-- breadcrumb -->
        <Breadcrumb wrapperClass="mb-7" :items="[
            { icon: true, name: 'settings01', route: { name: 'settings' } },
            { name: 'Business Profile', route: { name: 'settings.business' } }
        ]" />

        <form @submit.prevent="saveGeneralSettings">
            <!-- Basic Info -->
            <Card cardClass="gap-5 mb-5">
                <template #header>
                    <div class="flex flex-col gap-1">
                        <div class="text-[#101828] text-lg font-semibold">Basic Info</div>
                    </div>
                </template>

                <template #default>
                    <BusinessProfileInformation />
                </template>
            </Card>

            <!-- more details -->
            <Card cardClass="gap-5 mb-5">
                <template #header>
                    <div class="flex flex-col gap-1">
                        <div class="text-[#101828] text-lg font-semibold">More Details</div>
                    </div>
                </template>

                <template #default>
                    <BusinessProfileAddress />
                </template>
            </Card>

            <!-- Footer actions -->
            <div class="flex items-center gap-10">
                <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-7 justify-between" @click.prevent="backButton">
                    <div class="w-[70%]">Back</div>
                    <template #before>
                        <Icon name="arrowNarrowLeft" size="20px"></Icon>
                    </template>

                </Button>
                <Button size="xl" submit type="primary" radius="square" classButton="w-full mt-7 justify-center">
                    {{ $settings.isSaving ? 'Saving...' : 'Save' }}
                </Button>
            </div>
        </form>
    </div>
</template>
